import { addDays, differenceInCalendarDays } from 'date-fns';

interface DayRange {
  from: Date;
  to: Date;
}

/**
 * Earliest day in today .. today + `maxForwardDays` - 1 with a slot in
 * `slotsByDay`; `getDayKey` must match the keying used to build that cache.
 */
export function findFirstAvailableDay(search: {
  slotsByDay: Readonly<Record<string, readonly unknown[]>>;
  today: Date;
  maxForwardDays: number;
  getDayKey: (date: Date) => string;
}): Date | undefined {
  const { slotsByDay, today, maxForwardDays, getDayKey } = search;
  for (let offset = 0; offset < maxForwardDays; offset++) {
    const day = addDays(today, offset);
    if (slotsByDay[getDayKey(day)]?.length) {
      return day;
    }
  }
  return undefined;
}

/**
 * The page containing `day`, stepping from `range` in whole-page strides so it
 * lands on a page reachable via prev/next. Returns `range` when `day` is
 * already inside it.
 */
export function pageRangeContainingDay(range: DayRange, day: Date): DayRange {
  const pageLength = differenceInCalendarDays(range.to, range.from) + 1;
  const pagesToAdvance = Math.floor(differenceInCalendarDays(day, range.from) / pageLength);
  if (pagesToAdvance === 0) {
    return range;
  }
  const dayOffset = pageLength * pagesToAdvance;
  return {
    from: addDays(range.from, dayOffset),
    to: addDays(range.to, dayOffset),
  };
}
